import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm ${hover ? 'transition-shadow duration-200 hover:shadow-md' : ''} ${className}`} data-id="element-17">
      {children}
    </div>;
}